import { RegularExpressions } from "../../../../../../Helpers/RegularExpression";
import { ValForm, ValFormReg } from "../../../../../../Validators/ValForms";

export const ValPedidoFinanciamiento = (state) => {
  const vencimineto = ValForm("Vencimiento", state.vencimiento);
  const inicio_interes = ValForm("Inicio de Interes", state.inicio_interes);
  const importe = ValFormReg(
    "Importe",
    state.importe,
    RegularExpressions.TextOnlyNumber
  );
  const dias = ValFormReg(
    "Dias",
    state.dias,
    RegularExpressions.TextOnlyNumber
  );
  const tasa = ValFormReg(
    "Tasa",
    state.tasa,
    RegularExpressions.TextOnlyNumber
  );
  const intereses = ValFormReg(
    "Intereses",
    state.intereses,
    RegularExpressions.TextOnlyNumber
  );
  var isValid = true;
  var mensaje = "";
  if (vencimineto.isValid === false) {
    state.bvencimiento = true;
    isValid = false;
    mensaje += vencimineto.mensaje;
  }
  if (inicio_interes.isValid === false) {
    state.binicio_interes = true;
    isValid = false;
    mensaje += inicio_interes.mensaje;
  }
  if (importe.isValid === false) {
    state.bimporte = true;
    isValid = false;
    mensaje += importe.mensaje;
  }
  if (dias.isValid === false) {
    state.bdias = true;
    isValid = false;
    mensaje += dias.mensaje;
  }
  if (tasa.isValid === false) {
    state.btasa = true;
    isValid = false;
    mensaje += tasa.mensaje;
  }
  if (intereses.isValid === false) {
    state.bintereses = true;
    isValid = false;
    mensaje += intereses.mensaje;
  }

  if (isValid === false) {
    return { isValid, state, mensaje };
  } else {
    return {
      isValid,
      post: {
        folio: "",
        docto: "0",
        vencimiento: state.vencimiento,
        inicio_interes: state.inicio_interes,
        importefinanciar: Number(state.importe),
        dias: Number(state.dias),
        tasa: Number(state.tasa),
        interes: Number(state.intereses),
        totalpagar: Number(state.totalpagar),
      },
    };
  }
};
